import { Button, Spinner } from "@Rolec-Services/rolec-ui";
import { useTranslation } from "react-i18next";
import { FormState } from "~/utils/data";

type EndProps = Pick<FormState, "state" | "teamUrl">;

export function End({ state, teamUrl }: EndProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center gap-2 w-full h-full">
      <h1 className="text-2xl">{t("Onboarding")}</h1>
      <img src="/assets/monta-circle.svg" className="w-64" />
      <img src="/assets/powered-by-monta.svg" className="w-64" />
      <State state={state} teamUrl={teamUrl} />
    </div>
  );
}

function State({ state, teamUrl }: EndProps) {
  const { t } = useTranslation();

  if (!state) return;

  if (state === "submitted") return <Spinner className="size-24" />;

  if (state === "failed")
    return <p>{t("Onboarding failed - contact evsupport@eplucon.nl")}</p>;

  if (state === "successful")
    return (
      <div className="flex flex-col gap-6">
        <p>{t("Onboarding successful")}</p>
        {teamUrl && (
          <Button asChild>
            <a href={teamUrl}>{t("Monta Team Account")}</a>
          </Button>
        )}
      </div>
    );

  return;
}
